var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "type-chart" }, [
      _c("div", { attrs: { id: "type-price-chart" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }